const FORGEROCK_ACTION_TYPES = {
  IS_AUTHORIZED: 'IS_AUTHORIZED',
  AUTHORIZED_SUCCESS: 'AUTHORIZED_SUCCESS',
  AUTHORIZED_ERROR: 'AUTHORIZED_ERROR',
};

export default FORGEROCK_ACTION_TYPES;
